module.exports = __webpack_public_path__ + "static/fabric-table-compact-935f61c0aa7ced7c20285dbfa254a598.png";